// extracted by mini-css-extract-plugin
export default {"deletingWrap":"LocalImg_deletingWrap__QXhcV","content":"LocalImg_content__CBvZN","container":"LocalImg_container__0v2jh"};